<!-- eslint-disable max-len -->
<template>
  <!-- 
<div class="footer bg-white flex justify-around content-center shadow-lg"> -->
  <div class="w-full bg-white shadow-lg footer_main">
    <div class="body_inner">
      <div class="flex items-center w-full">
        <div
          :class="{
            'footer__element--active': currentRouteName === 'offerSearch'
          }"
          class="flex items-center justify-start w-2/6 menu_item footer_menu"
          @click="
            () => {
              if ($route.name !== 'offerSearch') {
                $router.push({ name: 'offerSearch' });
              }
            }
          "
        >
          <svg
            width="19"
            height="19"
            viewBox="0 0 19 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.25 0C3.25482 0 0 3.25482 0 7.25C0 11.2452 3.25482 14.5 7.25 14.5C8.97818 14.5 10.5669 13.8895 11.8145 12.875L16.7197 17.7803C16.7888 17.8523 16.8716 17.9097 16.9632 17.9493C17.0548 17.9889 17.1534 18.0098 17.2532 18.0108C17.3529 18.0118 17.4519 17.9929 17.5443 17.9552C17.6367 17.9175 17.7206 17.8617 17.7912 17.7912C17.8617 17.7206 17.9175 17.6367 17.9552 17.5443C17.9929 17.4519 18.0118 17.3529 18.0108 17.2532C18.0098 17.1534 17.9889 17.0548 17.9493 16.9632C17.9097 16.8716 17.8523 16.7888 17.7803 16.7197L12.875 11.8145C13.8895 10.5669 14.5 8.97818 14.5 7.25C14.5 3.25482 11.2452 0 7.25 0ZM7.25 1.5C10.4345 1.5 13 4.06548 13 7.25C13 8.80131 12.3881 10.2029 11.3955 11.2354C11.3343 11.2803 11.2803 11.3343 11.2354 11.3955C10.2029 12.3881 8.80131 13 7.25 13C4.06548 13 1.5 10.4345 1.5 7.25C1.5 4.06548 4.06548 1.5 7.25 1.5Z"
              fill="#676666"
            />
          </svg>
          <span class="menu-text">{{ $t("pages.footer.home_page") }}</span>
        </div>

        <div
          :class="{
            'footer__element--active': [
              'Applications',
              'RejectedApplications',
              'SelectedApplication',
              'RejectApplication',
              'CurrentFamily',
              'SelectionOtherPK',
              'ApplicationWaiting',
              'ApplicationProcess',
              'CallApplication',
              'RequestInformation'
            ].includes(currentRouteName)
          }"
          class="flex items-center justify-start w-2/6 menu_item footer_menu"
          @click="
            () => {
              if ($route.name !== 'Applications') {
                $router.push({ name: 'Applications' });
              }
            }
          "
        >
          <svg
            width="17"
            height="20"
            viewBox="0 0 17 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.75 0.5C1.51625 0.5 0.5 1.51625 0.5 2.75V17.25C0.5 18.4838 1.51625 19.5 2.75 19.5H9.25C9.43841 19.4994 9.61969 19.4279 9.75781 19.2998L9.75879 19.3008L16.2588 13.3008L16.2578 13.2998C16.3339 13.2298 16.3947 13.1448 16.4364 13.0502C16.478 12.9556 16.4997 12.8534 16.5 12.75V2.75C16.5 1.51625 15.4838 0.5 14.25 0.5H2.75ZM2.75 2H14.25C14.6732 2 15 2.32675 15 2.75V12H10.75C9.51625 12 8.5 13.0162 8.5 14.25V18H2.75C2.32675 18 2 17.6733 2 17.25V2.75C2 2.32675 2.32675 2 2.75 2ZM5.25 4.5C5.05109 4.5 4.86032 4.57902 4.71967 4.71967C4.57902 4.86032 4.5 5.05109 4.5 5.25C4.5 5.44891 4.57902 5.63968 4.71967 5.78033C4.86032 5.92098 5.05109 6 5.25 6C5.44891 6 5.63968 5.92098 5.78033 5.78033C5.92098 5.63968 6 5.44891 6 5.25C6 5.05109 5.92098 4.86032 5.78033 4.71967C5.63968 4.57902 5.44891 4.5 5.25 4.5ZM7.75 4.5C7.65062 4.49859 7.55194 4.51696 7.45972 4.55402C7.36749 4.59108 7.28355 4.6461 7.21277 4.71588C7.142 4.78566 7.08579 4.86882 7.04743 4.96051C7.00907 5.0522 6.98932 5.15061 6.98932 5.25C6.98932 5.34939 7.00907 5.4478 7.04743 5.53949C7.08579 5.63118 7.142 5.71434 7.21277 5.78412C7.28355 5.8539 7.36749 5.90892 7.45972 5.94598C7.55194 5.98304 7.65062 6.00141 7.75 6H11.25C11.3494 6.00141 11.4481 5.98304 11.5403 5.94598C11.6325 5.90892 11.7164 5.8539 11.7872 5.78412C11.858 5.71434 11.9142 5.63118 11.9526 5.53949C11.9909 5.4478 12.0107 5.34939 12.0107 5.25C12.0107 5.15061 11.9909 5.0522 11.9526 4.96051C11.9142 4.86882 11.858 4.78566 11.7872 4.71588C11.7164 4.6461 11.6325 4.59108 11.5403 4.55402C11.4481 4.51696 11.3494 4.49859 11.25 4.5H7.75ZM5.25 8C5.05109 8 4.86032 8.07902 4.71967 8.21967C4.57902 8.36032 4.5 8.55109 4.5 8.75C4.5 8.94891 4.57902 9.13968 4.71967 9.28033C4.86032 9.42098 5.05109 9.5 5.25 9.5C5.44891 9.5 5.63968 9.42098 5.78033 9.28033C5.92098 9.13968 6 8.94891 6 8.75C6 8.55109 5.92098 8.36032 5.78033 8.21967C5.63968 8.07902 5.44891 8 5.25 8ZM7.75 8C7.65062 7.99859 7.55194 8.01696 7.45972 8.05402C7.36749 8.09108 7.28355 8.1461 7.21277 8.21588C7.142 8.28566 7.08579 8.36882 7.04743 8.46051C7.00907 8.5522 6.98932 8.65061 6.98932 8.75C6.98932 8.84939 7.00907 8.9478 7.04743 9.03949C7.08579 9.13118 7.142 9.21434 7.21277 9.28412C7.28355 9.3539 7.36749 9.40892 7.45972 9.44598C7.55194 9.48304 7.65062 9.50141 7.75 9.5H11.25C11.3494 9.50141 11.4481 9.48304 11.5403 9.44598C11.6325 9.40892 11.7164 9.3539 11.7872 9.28412C11.858 9.21434 11.9142 9.13118 11.9526 9.03949C11.9909 8.9478 12.0107 8.84939 12.0107 8.75C12.0107 8.65061 11.9909 8.5522 11.9526 8.46051C11.9142 8.36882 11.858 8.28566 11.7872 8.21588C11.7164 8.1461 11.6325 8.09108 11.5403 8.05402C11.4481 8.01696 11.3494 7.99859 11.25 8H7.75ZM10.75 13.5H13.832L10 17.0371V14.25C10 13.8268 10.3268 13.5 10.75 13.5Z"
              fill="#333333"
            />
          </svg>
          <span class="menu-text">{{ $t("pages.footer.application") }}</span>
        </div>

        <div
          :class="{
            'footer__element--active': currentRouteName === 'favoriteOffers'
          }"
          class="flex items-center justify-start w-2/6 menu_item footer_menu"
          @click="
            () => {
              if ($route.name !== 'favoriteOffers') {
                $router.push({ name: 'favoriteOffers' });
              }
            }
          "
        >
          <svg
            width="21"
            height="18"
            viewBox="0 0 21 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 0.5C2.97122 0.5 0.5 2.97122 0.5 6C0.5 8.04808 2.04382 9.97645 3.92578 11.9541C5.80774 13.9318 8.12419 15.9347 9.96973 17.7803C10.1104 17.9209 10.3011 17.9999 10.5 17.9999C10.6989 17.9999 10.8896 17.9209 11.0303 17.7803C12.8758 15.9347 15.1923 13.9318 17.0742 11.9541C18.9562 9.97645 20.5 8.04808 20.5 6C20.5 2.97122 18.0288 0.5 15 0.5C13.2618 0.5 11.7484 1.43324 10.5 3.01855C9.25159 1.43324 7.73822 0.5 6 0.5ZM6 2C7.46429 2 8.68315 2.7792 9.86621 4.65039C9.93386 4.75727 10.0274 4.84531 10.1383 4.90632C10.2491 4.96732 10.3735 4.99931 10.5 4.99931C10.6265 4.99931 10.7509 4.96732 10.8617 4.90632C10.9726 4.84531 11.0661 4.75727 11.1338 4.65039C12.3168 2.7792 13.5357 2 15 2C17.2182 2 19 3.78178 19 6C19 7.20192 17.7938 9.02355 15.9883 10.9209C14.3418 12.6511 12.2952 14.4587 10.5 16.209C8.70484 14.4587 6.65821 12.6511 5.01172 10.9209C3.20618 9.02355 2 7.20192 2 6C2 3.78178 3.78178 2 6 2Z"
              fill="#333333"
            />
          </svg>
          <span class="menu-text">{{ $t("pages.footer.favorites") }}</span>
        </div>
        <div
          :class="{
            'footer__element--active': [
              'ProfileLanding',
              'ProfileEdit',
              'ProfileFAQ',
              'ProfileDocuments'
            ].includes(currentRouteName)
          }"
          class="flex items-center justify-start w-2/6 menu_item footer_menu"
          @click="
            () => {
              if ($route.name !== 'ProfileLanding') {
                $router.push({ name: 'ProfileLanding' });
              }
            }
          "
        >
          <svg
            width="16"
            height="20"
            viewBox="0 0 16 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 0C5.24746 0 3 2.24746 3 5C3 7.75254 5.24746 10 8 10C10.7525 10 13 7.75254 13 5C13 2.24746 10.7525 0 8 0ZM8 1.5C9.94188 1.5 11.5 3.05812 11.5 5C11.5 6.94188 9.94188 8.5 8 8.5C6.05812 8.5 4.5 6.94188 4.5 5C4.5 3.05812 6.05812 1.5 8 1.5ZM1.98926 12C0.899352 12 0 12.8994 0 13.9893V14.75C0 16.5521 1.13963 17.9461 2.65332 18.7812C4.16701 19.6164 6.08405 20 8 20C9.91595 20 11.833 19.6164 13.3467 18.7812C14.6373 18.0692 15.6087 16.9313 15.8809 15.5H16.001V13.9893C16.001 12.8994 15.1006 12 14.0107 12H1.98926ZM1.98926 13.5H14.0107C14.2898 13.5 14.501 13.7102 14.501 13.9893V14H14.5V14.75C14.5 15.9479 13.8271 16.8039 12.6221 17.4688C11.417 18.1336 9.70905 18.5 8 18.5C6.29095 18.5 4.58299 18.1336 3.37793 17.4688C2.17287 16.8039 1.5 15.9479 1.5 14.75V13.9893C1.5 13.7102 1.71016 13.5 1.98926 13.5Z"
              fill="#63B15B"
            />
          </svg>
          <span class="menu-text">{{ $t("pages.footer.profile") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  computed: {
    currentRouteName() {
      return this.$route.name;
    }
  }
};
</script>
<style>
.footer_main {
  height: auto;
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 14px 0;
}

.footer_main .footer_menu {
  flex-direction: column;
  text-align: center;
  color: #d1d1d1;
}

.footer_main .footer_menu .menu-text {
  display: block;
  width: 100%;
  color: #d1d1d1;
  text-transform: capitalize;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  margin: 7px 0 0;
  font-size: 0.75rem;
}

.footer_main .footer_menu svg {
  width: 20px;
  height: 20px;
}

.footer_main .footer_menu svg path {
  fill: #c1c1c1;
}

.footer_main .footer_menu.footer__element--active {
  color: #676666;
}

.footer_main .footer_menu.footer__element--active .menu-text {
  color: #676666;
}

.footer_main .footer_menu.footer__element--active svg {
}

.footer_main .footer_menu.footer__element--active svg path {
  fill: #63b15b;
}
</style>
